import { render, staticRenderFns } from "./question-matrix-comparison.vue?vue&type=template&id=04fed010&scoped=true"
import script from "./question-matrix-comparison.vue?vue&type=script&lang=js"
export * from "./question-matrix-comparison.vue?vue&type=script&lang=js"
import style0 from "./question-matrix-comparison.vue?vue&type=style&index=0&id=04fed010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fed010",
  null
  
)

export default component.exports